var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimSubmitDNotFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.785645,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#0C66E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9712 10.6348C13.9712 12.0449 13.5688 13.125 12.7642 13.875C11.9634 14.625 10.8052 15 9.28955 15H6.86377V6.43359H9.55322C10.9517 6.43359 12.0376 6.80273 12.811 7.54102C13.5845 8.2793 13.9712 9.31055 13.9712 10.6348ZM12.0845 10.6816C12.0845 8.8418 11.272 7.92188 9.64697 7.92188H8.68018V13.5H9.45947C11.2095 13.5 12.0845 12.5605 12.0845 10.6816Z",
    fill: "#0C66E3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimSubmitDNotFill);
export default __webpack_public_path__ + "static/media/claimSubmitDNotFill.0a0285c17927abe7be142ed86708b7d9.svg";
export { ForwardRef as ReactComponent };